"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  MessageStrip: true
};
exports.default = exports.MessageStrip = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon/Icon");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _IconButton = require("../IconButton/IconButton");
var _isInfoIcon = require("../utils/isInfoIcon");
var _MessageStrip = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageStrip.css") : void 0);
var _MessageStrip2 = require("./MessageStrip.types");
Object.keys(_MessageStrip2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _MessageStrip2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MessageStrip2[key];
    }
  });
});
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-messagestrip';
/**
 * The **MessageStrip** component displays state-related messages to the user.
 * It is intended to be part of the page layout and is more permanent than an
 * overlay (_e.g._ **MessageDialog**, **Popover**).
 *
 * See the [Patterns/Message Handling](./?path=/docs/patterns-message-handling--docs) page
 * for more detailed information on selecting the appropriate messaging component.
 */
const MessageStrip = exports.MessageStrip = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _a = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(MessageStrip, props)) : props,
    {
      buttonProps,
      className,
      dismissible,
      iconProps,
      message,
      messageProps,
      type,
      typeLabel
    } = _a,
    otherProps = __rest(_a, ["buttonProps", "className", "dismissible", "iconProps", "message", "messageProps", "type", "typeLabel"]);
  const classnames = _bind.default.bind(_MessageStrip.default);
  const iconName = (0, _react.useMemo)(() => (0, _isInfoIcon.isInfoIcon)(type) ? type : `messaging-${type}`, [type]);
  const classes = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--${(0, _isInfoIcon.isInfoIcon)(type) ? 'info' : type}`]: type,
    [`${CSS_BLOCK}--dismiss`]: dismissible
  });
  return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, otherProps, {
    className: classes,
    "data-hcm": "bordered",
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: classnames(`${CSS_BLOCK}__screen-reader-only`)
  }, typeLabel), /*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({}, iconProps, {
    ariaHidden: true,
    className: classnames(`${CSS_BLOCK}__icon`, iconProps === null || iconProps === void 0 ? void 0 : iconProps.className, {
      [`${CSS_BLOCK}__info-icon`]: (0, _isInfoIcon.isInfoIcon)(type)
    }),
    iconName: iconName,
    size: "sm"
  })), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, messageProps, {
    className: classnames(`${CSS_BLOCK}__message`, messageProps === null || messageProps === void 0 ? void 0 : messageProps.className)
  }), message), dismissible && (/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({
    ariaLabel: dismissible.dismissLabel
  }, buttonProps, {
    forceSize: "compact",
    className: classnames(`${CSS_BLOCK}__dismiss`, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className),
    "data-test": "closeButton",
    iconName: "close",
    iconProps: Object.assign({
      forceSize: 'xs-plus'
    }, buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.iconProps),
    onClick: dismissible.onDismiss
  }))));
});
MessageStrip.displayName = 'MessageStrip';
var _default = exports.default = MessageStrip;